// extracted by mini-css-extract-plugin
export var dividerContainer = "_9w-0";
export var line = "_9w-1";